import isEmpty from 'lodash/isEmpty';
import { fetchStatus } from '@/vuex/modules/blacklist/blacklist.utils';

const blacklist = {
    namespaced: true,
    state: {
        statusMap: {},
    },
    mutations: {
        setStatusMap (state, { map }) {
            state.statusMap = map;
        },
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
        setError (state, { error }) {
            state.error = error;
        },
    },
    actions: {
        async loadStatus ({ commit, state }, { reFetch = false } = {}) {
            if (!isEmpty(state.statusMap) && !reFetch) {
                return;
            }

            try {
                commit('setFetching', { fetching: true });
                const statuses = await fetchStatus();
                commit('setStatusMap', { map: statuses });
                commit('setFetching', { fetching: false });
            } catch (error) {
                commit('setError', { error });
                commit('setFetching', { fetching: false });
            }
        },
    },
    getters: {
        enabled: (state) => Object.keys(state.statusMap).filter((status) => state.statusMap[status]).length > 0,
    },
};

export default blacklist;
